
import React from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface ReplyHeaderProps {
  replyToId: string | null;
  onCancelReply: () => void;
}

const ReplyHeader: React.FC<ReplyHeaderProps> = ({ replyToId, onCancelReply }) => {
  if (!replyToId) return null;
  
  return (
    <div className="mb-2 flex justify-between items-center">
      <div className="text-sm text-muted-foreground italic">
        Reageren op een bericht
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onCancelReply}
        className="h-6 px-2"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ReplyHeader;
